import _classCallCheck from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/common/config_provider.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["children", "rtlEnabled"];
import { BaseInfernoComponent } from "@devextreme/vdom";
export var viewFunction = function viewFunction(viewModel) {
  return viewModel.props.children;
};
export var ConfigProviderProps = {};
export var ConfigProvider =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(ConfigProvider, _BaseInfernoComponent);

  function ConfigProvider(props) {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return _extends({}, this.context, {
        ConfigContext: this.config
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props),
        config: this.config,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "config",
    get: function get() {
      return {
        rtlEnabled: this.props.rtlEnabled
      };
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

      return restProps;
    }
  }]);

  return ConfigProvider;
}(BaseInfernoComponent);
ConfigProvider.defaultProps = _extends({}, ConfigProviderProps);